var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _mask, _path4, _path5, _mask2, _path6, _path7, _rect5, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#1AA179"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.128 63.4773C114.56 61.6364 113.776 59.9886 112.776 58.5341C111.798 57.0568 110.616 55.7955 109.23 54.75C107.866 53.7045 106.298 52.9205 104.526 52.3977C102.753 51.8523 100.821 51.5795 98.7301 51.5795C94.9801 51.5795 91.6392 52.5227 88.7074 54.4091C85.7756 56.2955 83.4688 59.0682 81.7869 62.7273C80.1278 66.3636 79.2983 70.7955 79.2983 76.0227C79.2983 81.2955 80.1278 85.7614 81.7869 89.4205C83.446 93.0795 85.7528 95.8636 88.7074 97.7727C91.6619 99.6591 95.0938 100.602 99.0028 100.602C102.548 100.602 105.616 99.9205 108.207 98.5568C110.821 97.1932 112.832 95.2614 114.241 92.7614C115.651 90.2386 116.355 87.2841 116.355 83.8977L119.219 84.3409H100.264V74.4545H128.594V82.8409C128.594 88.8182 127.321 93.9886 124.776 98.3523C122.23 102.716 118.73 106.08 114.276 108.443C109.821 110.784 104.707 111.955 98.9347 111.955C92.5028 111.955 86.8551 110.511 81.9915 107.625C77.1506 104.716 73.3665 100.591 70.6392 95.25C67.9347 89.8864 66.5824 83.5227 66.5824 76.1591C66.5824 70.5227 67.3778 65.4886 68.9688 61.0568C70.5824 56.625 72.8324 52.8636 75.7188 49.7727C78.6051 46.6591 81.9915 44.2955 85.8778 42.6818C89.7642 41.0455 93.9915 40.2273 98.5597 40.2273C102.423 40.2273 106.026 40.7955 109.366 41.9318C112.707 43.0455 115.673 44.6364 118.264 46.7045C120.878 48.7727 123.026 51.2273 124.707 54.0682C126.389 56.9091 127.491 60.0455 128.014 63.4773H115.128ZM153.472 41.1818V111H140.824V41.1818H153.472ZM167.168 111V41.1818H211.895V51.7841H179.815V70.7386H208.827V81.3409H179.815V111H167.168Z",
    fill: "#FAFAFD"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_106_634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 210C135 201.163 142.163 194 151 194H323.082C331.918 194 339.082 201.163 339.082 210V398.082H135V210Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135 210C135 201.163 142.163 194 151 194H323.082C331.918 194 339.082 201.163 339.082 210V398.082H135V210Z",
    fill: "#FAFAFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133 210C133 200.059 141.059 192 151 192H323.082C333.023 192 341.082 200.059 341.082 210H337.082C337.082 202.268 330.814 196 323.082 196H151C143.268 196 137 202.268 137 210H133ZM339.082 398.082H135H339.082ZM133 398.082V210C133 200.059 141.059 192 151 192V196C143.268 196 137 202.268 137 210V398.082H133ZM323.082 192C333.023 192 341.082 200.059 341.082 210V398.082H337.082V210C337.082 202.268 330.814 196 323.082 196V192Z",
    fill: "black",
    fillOpacity: 0.05,
    mask: "url(#path-9-inside-1_106_634)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-2_106_634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 398.082H339.082V428C339.082 436.837 331.918 444 323.082 444H151C142.163 444 135 436.837 135 428V398.082Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135 398.082H339.082V428C339.082 436.837 331.918 444 323.082 444H151C142.163 444 135 436.837 135 428V398.082Z",
    fill: "#FAFAFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135 398.082H339.082H135ZM341.082 428C341.082 437.942 333.023 446 323.082 446H151C141.059 446 133 437.942 133 428H137C137 435.732 143.268 442 151 442H323.082C330.814 442 337.082 435.732 337.082 428H341.082ZM151 446C141.059 446 133 437.942 133 428V398.082H137V428C137 435.732 143.268 442 151 442V446ZM341.082 398.082V428C341.082 437.942 333.023 446 323.082 446V442C330.814 442 337.082 435.732 337.082 428V398.082H341.082Z",
    fill: "black",
    fillOpacity: 0.05,
    mask: "url(#path-11-inside-2_106_634)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 149.578,
    y: 208.578,
    width: 174.927,
    height: 174.927,
    fill: "#E9ECEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217.363 334.672V263.973L272.757 295.314L217.363 334.672Z",
    fill: "#1AA179"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_634",
    x: 54.582,
    y: 40.2266,
    width: 161.312,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_634",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.a39a969e460ad06601b7078fdaa57ec1.svg";
export { ForwardRef as ReactComponent };